import { useState, useEffect } from "react";
import { isObjectId } from "../../../config/ProjectConfig";
import { AuthFetch } from "../../../routes";
import stringify from 'fast-json-stable-stringify';

const EditProjectHelpers = ({ 
    setAlert, 
    setLoading, 
    loadMicropileProperties,
    loadSoilTable,  
    loadZwgLevels,
    loadSaftyFactors, 
    loadTitle,
    loadResults, 
    onLoadFileName,
    onLoadProfileName,

    onSetMainProjectName,
    onSetSoilProfileMainProjectName,

    projectId
}) => {

    const [currentProjectId, setCurrentProjectId] = useState('');
    const [currentProfileId, setCurrentProfileId] = useState('');
    const [loadProjectState, setLoadProjectState] = useState(false);
    const [currentProjectLoaded, setCurrentProjectLoaded] = useState(false);
    const micropilesCurrentProject = JSON.parse(localStorage.getItem('micropiles')) || {};

    const updateStateOnLoad = (response) => {
        const { model={}, results={}, projectName='' } = response.responseData;     

        setLoadProjectState(true);
        onSetMainProjectName(() => ({ 
            isValid: true,
            value: response.responseData.projectId.name
        }));
        onSetSoilProfileMainProjectName(() => ({
            value: response.responseData.projectId.name
        }));

        setCurrentProjectId(response.responseData.projectId.id);
        setCurrentProfileId(response.responseData.profileId);

        onLoadFileName({
            state: projectName ? 'loaded' : 'init',
            value: projectName
        });
        onLoadProfileName({ 
            state: 'init',
            value: '' 
        });

        loadMicropileProperties(model.micropileParameters);
        loadSoilTable(model.soilsCollection);
        loadZwgLevels(model.zwgLevels);
        loadSaftyFactors(model.saftyFactors); 
        loadTitle({
            projectTitle: model.projectTitle
        });

        setTimeout(() => {
            loadResults({
                isResultsActive: results.isResultsActive,
                results: {
                    isResultsActual: results.isResultsActual,
                    ...results.results
                }
            })
        },0)
    };

    useEffect(() => {
        if(!currentProjectLoaded && micropilesCurrentProject.id && micropilesCurrentProject.projectId){
            setLoadProjectState(false);
            AuthFetch({
                url: `/api/micropilePull/calculations/${micropilesCurrentProject.id}/${micropilesCurrentProject.projectId}`,
                method: 'GET',
            }).then(response => {
                if(response.success){
                    setCurrentProjectLoaded(true);
                    updateStateOnLoad(response);
                }
            })
        }
    },[currentProjectLoaded, micropilesCurrentProject.id, micropilesCurrentProject.projectId]);

    const onLoadProject = (id)=> {
        if(isObjectId(id) && isObjectId(projectId)){
            setLoading({ name: 'fetchProject', loading: true });
            setLoadProjectState(false);
            AuthFetch({
                url: `/api/micropilePull/calculations/${id}/${projectId}`,
                method: 'GET',
            }).then(response => {
                setLoading({ name: 'fetchProject', loading: false });
                if(response.success) {
                    localStorage.setItem('micropiles', stringify({ id: response.responseData.id, projectId: response.responseData.projectId.id }));
                    setCurrentProjectLoaded(true);
                    updateStateOnLoad(response);
                } else {
                    setAlert({ error: true, message: 'Błąd podczas wczytywania projektu' });
                }
            })
            .catch(() => {
                setAlert({ error: true, message: 'Błąd podczas wczytywania projektu' });
            })
        }

    }
 
    const editProject = {
        onLoadProject: onLoadProject,
        currentProjectId: currentProjectId,
        currentProfileId: currentProfileId,
        loadProjectState: loadProjectState
    }

    return {
        editProject
    }
}

export default EditProjectHelpers